<template>
  <div class="show-big-image"
       v-if="isShowFileImage">
    <img :src="prevImage"
         class="prev-image"
         alt=""
         @click="prevFunc">
    <img :src="nextImage"
         class="next-image"
         alt=""
         @click="nextFunc">
    <div v-if="bigImage"
         class="show-image-content">
      <span class="show-image-name">{{curFile.name}}</span>
      <img :src="bigImage"
           alt=""
           class="show-image">
    </div>
    <a :href="fileUrl"
       class="show-image show-file"
       v-if="!bigImage"
       target="_blank">{{curFile.name}}</a>
    <img :src="closeImage"
         alt=""
         class="close-image"
         @click="close">
  </div>
</template>
<script>
export default {
  props: {
    isShowFileImage: {
      type: Boolean,
      default: false,
    },
    filesList: {
      type: Array,
      default: () => [],
    },
    curFile: {
      type: Object,
      default: () => {},
    },
    bigImage: {
      type: '',
      default: '',
    },
    fileUrl: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      prevImage: require('../../../../assets/images/prev.png'),
      nextImage: require('../../../../assets/images/next.png'),
      closeImage: require('../../../../assets/images/fileType/close.png'),
    }
  },
  methods: {
    prevFunc () {
      let index = this.filesList.findIndex(
        (obj) => obj.name === this.curFile.name
      )
      if (index === 0) {
        this.$emit(
          'showImage',
          this.filesList[this.filesList.length - 1],
          false
        )
      } else {
        this.$emit('showImage', this.filesList[index - 1], false)
      }
    },
    nextFunc () {
      let index = this.filesList.findIndex(
        (obj) => obj.name === this.curFile.name
      )
      if (index === this.filesList.length - 1) {
        this.$emit('showImage', this.filesList[0], false)
      } else {
        this.$emit('showImage', this.filesList[index + 1], false)
      }
    },
    close () {
      this.$emit('closeLargeImage')
    },
  },
}
</script>
<style  lang='scss' scoped>
.show-big-image {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background-color: rgba(51, 51, 51, 0.7);
  text-align: center;
  padding: 5% 10% 0;
  overflow: scroll;
  padding-bottom: 20px;
  .show-image {
    max-width: 100%;
    width: auto;
    height: auto;
    margin-top: 10%;
  }
  // .show-image-content {
  //   display: flex;
  //   flex-direction: column;
  // }
  .show-image-name {
    color: #fff;
    padding-bottom: 20px;
    display: block;
  }
  .close-image {
    cursor: pointer;
    position: absolute;
    top: 5%;
    right: 3%;
    width: 40px;
    height: auto;
  }
  .prev-image {
    position: absolute;
    top: 45%;
    left: 1%;
    width: 80px;
    height: auto;
    transform: translate(0, -50%);
    cursor: pointer;
  }
  .next-image {
    position: absolute;
    top: 45%;
    right: 1%;
    width: 80px;
    height: auto;
    transform: translate(0, -50%);
    cursor: pointer;
  }
  .show-file {
    margin-top: 10%;
    display: inline-block;
    font-size: 30px;
    color: #fff;
  }
  .show-file:hover {
    color: #409eff;
  }
}
</style>
